<template>
  <ContentContainer :loadingStatus="false">
    <div class="agent-type content-wrapper">
      <div class="page-header">{{ $t('editAgentType') }}</div>
      <div style="margin-bottom: 40px; margin-left: 5px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'SettingAgentTypeList' }">{{ $t('agentType') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('editAgentType') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" label-width="150px" style="width: 500px">
        <el-form-item :label="$t('name')">
          <el-input v-model="agentType.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('description')">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="Please input"
            v-model="agentType.detail">
          </el-input>
        </el-form-item>
      </el-form>
      <el-form ref="form" label-width="150px" style="width: 500px; margin-top: 40px">
        <el-form-item>
          <el-button type="primary" @click="onSaveChangesButtonClick">{{ $t('saveChanges') }}</el-button>
          <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </ContentContainer>
</template>

<script>
import i18nMessages from '@/translations/Setting/ManageSetting/AgentType/Edit.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent'
import SettingAgentTypeApi from '@/api/setting/agent-type-api'

export default {
  name: 'SettingAgentTypeEdit',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  props: {
    agentType: {
      type: Object,
      default: function () {
        return {
          id: '',
          name: '',
          detail: ''
        }
      }
    }
  },
  created () {
    if (this.agentType.id === undefined || this.agentType.id === '') {
      this.$router.push({
        name: 'SettingAgentTypeList'
      })
    }
  },
  methods: {
    onSaveChangesButtonClick: async function () {
      try {
        this.startLoading()

        await SettingAgentTypeApi.update(this.agentType.id, this.agentType)

        const title = this.$t('updateAgentTypeSuccessTitle')
        const message = this.$t('updateAgentTypeSuccessMessage')
        this.showNotificationSuccess(title, message)

        this.$router.push({
          name: 'SettingAgentTypeList'
        })
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'SettingAgentTypeList'
      })
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
</style>
